import classNames from 'classnames';
import LoadingButton from 'components/LoadingButton';
import React from 'react';

const renderCardNumber = (card) => {
  if (card.cardType === 3) {
    return `${card.cardNumber.slice(0, 4)} ${card.cardNumber.slice(
      4,
      10
    )} ${card.cardNumber.slice(10)}`;
  }
  return card.cardNumber.replace(/(\w{4})/g, '$1 ').trim();
};

const SavedCards = ({
  paymentCards,
  paymentCardsFetched,
  selectedCard,
  isCardSelected,
  setSelectedCard,
  getCardUrl,
}) => {
  const showLoader = !paymentCards && !paymentCardsFetched;

  return (
    <>
      <div className='detailsTitle !mt-2'>
        <h1>Saved cards</h1>
      </div>

      <div className='!overflow-auto !mb-10'>
        {showLoader ? (
          <LoadingButton />
        ) : paymentCards?.length === 0 ? (
          <div className='text-sm text-gray-500 italic px-2 py-4'>
            No saved cards available.
          </div>
        ) : (
          paymentCards.map((card, index) => {
            const isActive =
              card.token === selectedCard?.token && isCardSelected;

            return (
              <div
                key={index}
                className={classNames('cardCommon cash !mt-2', {
                  active: isActive,
                })}
                onClick={() => setSelectedCard(card)}
              >
                <span>{renderCardNumber(card)}</span>
                <img src={getCardUrl(card.cardType)} alt='' />
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default SavedCards;
